import { useCarbarAuAuthStore } from '@/stores/carbar-au-auth'

export default defineNuxtRouteMiddleware(async (to) => {
	const authStore = useCarbarAuAuthStore()
	const { signInUrl, signUpUrl, navigateToLogin, navigateToAccount } =
		useAuthPaths(to.path)

	if (authStore.isLoggedIn) {
		// The server can't check the API session, so the browser does it after hydration
		if (import.meta.server) {
			return
		}

		if (!(await authStore.verifySession())) {
			return navigateToLogin()
		}

		const redirect = to.query._redirect

		if (redirect) {
			return navigateTo(redirect, { external: true })
		}

		return navigateToAccount()
	}

	// OTP session validation only applies to the verify-otp page
	if (!to.path.endsWith('/verify-otp')) {
		return
	}

	if (!authStore.userToken || !authStore.otpEmail) {
		// No OTP context at all — user wandered to /verify-otp directly
		if (!authStore.otpFlow) {
			return navigateToLogin()
		}

		// User came through the flow but session data is missing — session expired
		let destination = signInUrl.value

		if (authStore.otpFlow === 'signup') {
			// Use whitelabel signup link if it exists, otherwise default
			destination = signUpUrl.value
		} else {
			// Use whitelabel signin link if it exists, otherwise default
			destination = signInUrl.value
		}

		const sessionErrorMessage =
			authStore.otpFlow === 'signup'
				? 'Session expired. Please sign up again.'
				: 'Session expired. Please sign in again.'

		authStore.setSessionError(sessionErrorMessage)
		return navigateTo(destination)
	}
})
